export const dueDateTypeValue = {
  DATE_CREATED: '1',
  RELATIVE_TO_TASK_CREATED: '2',
  RELATIVE_TO_TASK_DUE: '3',
};
